import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import required modules
import { Autoplay, EffectFade, Navigation } from 'swiper/modules';
import showToast from "../helpers/show_toast";
import { getSubmitForm } from "../helpers/forms_helper";
import { useEffect, useState } from 'react';
import Loader from './Loader';

const Slider = () => {
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetch_data();
    }, []);

    const fetch_data = async () => {
        setLoading(true)
        let url = "https://api.jmialumnivic.com.au/sliders/getall"
        let response = await getSubmitForm(url, "");
        if (response && response.status === 1) {
            setAllData(response.data);
            setLoading(false)
        } else {
            setLoading(false)
            showToast(response.error, "error")
        }
    };
    return (
        <>
            <section id="slider-area">
                <div className="slider-active-wrap owl-carousel  text-center text-md-start" id="slider">
                    <div className="single-slide-wrap ">
                        <Swiper
                            grabCursor
                            spaceBetween={5} navigation={true}
                            autoplay={{
                                delay: 4000,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            effect={'fade'} loop={true}
                            modules={[Autoplay, EffectFade, Navigation]}
                            className="mySwiper"
                        >
                            {loading ?
                                <SwiperSlide>
                                    <div className="slider_img_two bg-light" >
                                        <Loader />
                                    </div>
                                </SwiperSlide>
                                : allData && allData.length > 0 ?
                                    allData?.map((img, idx) => (
                                        <SwiperSlide key={idx}>
                                            <div className="slider_img_two" style={{ backgroundImage: `url(${img.image_url})` }}>
                                                <div className="slider_layer"></div>
                                            </div>
                                        </SwiperSlide>
                                    ))
                                    : ''
                            }
                        </Swiper>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Slider
